<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_map_settings')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        Sometimes it might be useful to visualize your scanning range on the map, you can enable this in the map settings <GenericIcon type="cog"/>.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on the cog <GenericIcon type="cog"/> next to the zoom levels, from there you can enable the "Scan Range Map".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">Got it!</ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>